import { LuX } from '@react-icons/all-files/lu/LuX'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import DocumentHeadTags from 'components/document-head-tags'
import { Dialog, Flex, IconButton } from 'components/ds'

import MailingListForm from './form'

/**
 * Create/edit mailing list dialog. Renders over the mailing lists table (it
 * is mounted in the table route's Outlet) so the table stays visible behind.
 */
const ContactsMailingListEdit = (): React.ReactElement => {
  const navigate = useNavigate()
  const params = useParams<{ listId?: string }>()

  const listId = params.listId ? parseInt(params.listId, 10) : undefined
  const title = listId ? 'Edit Mailing List' : 'Create Mailing List'

  const close = () => navigate('/lists')

  return (
    <>
      <DocumentHeadTags title={`${title} | DISCO`} />
      <Dialog.Root
        open
        onOpenChange={open => {
          if (!open) close()
        }}
      >
        <Dialog.Content maxWidth="480px" aria-describedby={undefined}>
          <Flex justify="between" align="start" mb="4">
            <Dialog.Title size="5" mb="0">
              {title}
            </Dialog.Title>
            <IconButton
              variant="ghost"
              color="gray"
              size="2"
              aria-label="Close"
              onClick={close}
            >
              <LuX size={18} />
            </IconButton>
          </Flex>
          <MailingListForm listId={listId} onClose={close} />
        </Dialog.Content>
      </Dialog.Root>
    </>
  )
}

export default ContactsMailingListEdit
